import React, { useContext } from "react";
import { Dropdown, DropdownButton, OverlayTrigger, Tooltip } from "react-bootstrap";
import { AuthContext } from "../../../context/AuthContext";

const DropDownSpfPermission = ({ permission, history }) => {
  const { isAllowed } = useContext(AuthContext);

  const navegar = (path, tipo) => {
    history.push({ pathname: path, state: { tipoOrigem: tipo } });
  };

  return isAllowed(permission) ? (
    <DropdownButton id="dropdown-basic-button" title="Novo Procedimento Fiscal">
      <Dropdown.Item onClick={() => navegar("/app/spf/form", "")}>Individual/Lote</Dropdown.Item>
      <Dropdown.Item onClick={() => navegar("/app/spf/origem", "C")}>Cobrança</Dropdown.Item>
      <Dropdown.Item onClick={() => navegar("/app/spf/origem", "D")}>Denúncia</Dropdown.Item>
      <Dropdown.Item onClick={() => navegar("/app/spf/origem", "P")}>Parte de Serviço</Dropdown.Item>
      <Dropdown.Item onClick={() => navegar("/app/spf/form", "S")}>Processo SEI</Dropdown.Item>
    </DropdownButton>
  ) : (
    <OverlayTrigger overlay={<Tooltip id="tooltip-disabled">Acesso negado</Tooltip>}>
      <span className="d-inline-block">
        <DropdownButton style={{ pointerEvents: "none" }} title="Novo Procedimento Fiscal" disabled />
      </span>
    </OverlayTrigger>
  );
};

export default DropDownSpfPermission;
